var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('r-button',_vm._g({class:{'flip-horizontal': _vm.flipIcon},attrs:{"size":"16px","color":"primary","textColor":"riseup-beige","padding":"12px","icon":_vm.icon,"round":"","unelevated":""}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }